import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, toObservable } from "keautils";
import { observeResource } from "kea-resource";
import { validation, formfields } from "kea-react"
import { fa } from "app/main/std";

type Entity = models.BitacoraRADPaquete;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}


export function validar(x: Entity) {

    const rules: validation.Rules<Entity> = {
        Cantidad: validation.and(validation.required, validation.integer, validation.range(1)),
        Peso: validation.and(validation.required, validation.rangeEx(0)),
        Alto: validation.and(validation.required, validation.rangeEx(0)),
        Ancho: validation.and(validation.required, validation.rangeEx(0)),
        Largo: validation.and(validation.required, validation.rangeEx(0)),
        IdContenidoPaquete: validation.required,
        IdDescripcionPaquete: validation.required
    };
    return validation.getErrors(rules, x);
}



/**
* Modal de edición para un PaqueteDocumentacion
*/
export class PaqueteRADEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));

    getField = formfields(() => this.props, () => this.errors(this.props));

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }

    private onHandleDescripcionPaqueteChange = async (idDescripcionPaquete: number) => {
        const viejo = this.props.value;
        const cambioPaquete: Partial<Entity> = { IdDescripcionPaquete: idDescripcionPaquete, };
        this.props.onChange({ ...viejo, ...cambioPaquete });

        var descripcionPaquete = await resources.DescripcionPaquete.getMemo(idDescripcionPaquete);
        const nuevo = this.props.value;
        const idContenidoPaquete = nuevo.IdContenidoPaquete;

        const contiene = descripcionPaquete.ContenidosPaquetes.filter(x => x.IdContenidoPaquete == idContenidoPaquete).length > 0;
        const cambio: Partial<Entity> = {
            Peso: descripcionPaquete.Peso || undefined,
            Largo: descripcionPaquete.Largo || undefined,
            Alto: descripcionPaquete.Alto || undefined,
            Ancho: descripcionPaquete.Ancho || undefined,
            IdContenidoPaquete: contiene || !descripcionPaquete.VerSoloContenidosPaquetesRelacionados ? idContenidoPaquete : undefined
        };
        this.props.onChange({ ...nuevo, ...cambio });
    }

    IdDescripcionPaquete = (props: Props) => props.value.IdDescripcionPaquete || null;

    private DescripcionPaquete = createSelectorRx(this.IdDescripcionPaquete, id => {
        const ret = id != null ? observeResource(resources.DescripcionPaquete.getMemo, id) : null;
        return toObservable(ret);
    });

    itemsUsados = createSelectorRx(this.DescripcionPaquete, resources.ContenidoPaquete.query, (DescripcionPaquete, items) =>
        DescripcionPaquete != null && DescripcionPaquete.VerSoloContenidosPaquetesRelacionados ?
            items.filter(x => DescripcionPaquete.ContenidosPaquetes.map(x => x.IdContenidoPaquete).indexOf(x.IdRegistro) != -1)
            : items
    );

    render() {
        const itemsUsados = this.itemsUsados(this.props);

        const getField = this.getField;
        const Number = getField(kea.Number);
        const Descripcion = getField(selectores.DescripcionPaquete);
        const Contenido = getField(selectores.ContenidoPaquete);
        const hasError = this.hasError(this.props);
        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Paquete"
            >

                {kea.autogrid(6, [
                    <div>
                        <kea.Panel title="General">
                            {kea.autogrid(6, [
                                <Descripcion field="IdDescripcionPaquete" label="Descripción paquete" onChange={this.onHandleDescripcionPaqueteChange} />,
                                <Contenido field="IdContenidoPaquete" label="Contenido paquete" items={itemsUsados} />,
                                <Number field="Cantidad"  />,
                                <Number field="Peso" label="Peso (kg)" />,
                            ])}
                        </kea.Panel>
                    </div>,
                    <div>
                        <kea.Panel title="Volumen" iconClass={fa("cube")} >
                            {kea.autogrid(4, [
                                <Number field="Largo" label="Largo (cm)" />,
                                <Number field="Alto" label="Alto (cm)" />,
                                <Number field="Ancho" label="Ancho (cm)" />,
                            ])}
                        </kea.Panel>
                    </div>
                    ,
                ])}
            </kea.Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/bitacoraRAD/edit/paquetes/edit.tsx